import * as React from 'react';

const NewsIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={18}>
    <path
      fill={fillColor}
      d="M.958 14.833a.603.603 0 0 1-.445-.18.61.61 0 0 1-.18-.448.61.61 0 0 1 .625-.621h1.125V7.207c0-1.139.344-2.17 1.032-3.093a4.414 4.414 0 0 1 2.718-1.74v-.604c0-.32.113-.583.34-.792.225-.208.5-.312.822-.312.323 0 .599.104.828.312.23.209.344.472.344.792v.604a4.456 4.456 0 0 1 2.729 1.74 5.023 5.023 0 0 1 1.041 3.093v6.375h1.105c.177 0 .325.06.445.181.12.12.18.27.18.448s-.06.326-.18.444a.61.61 0 0 1-.445.177H.958ZM7 17.333c-.444 0-.833-.163-1.167-.49a1.588 1.588 0 0 1-.5-1.176h3.334c0 .458-.164.85-.49 1.177-.326.326-.719.49-1.177.49Zm-3.667-3.75h7.354V7.208c0-1.041-.35-1.92-1.052-2.635C8.934 3.858 8.066 3.5 7.031 3.5c-1.034 0-1.91.358-2.625 1.073-.715.715-1.073 1.594-1.073 2.635v6.375Z"
    />
  </svg>
);

export default NewsIcon;
